export default __webpack_public_path__ + "43b25807f4966fbc64519aa0086a0efc.png";